import React from "react";
import useApiRequest from "./useFetch";
import Carousel from "react-grid-carousel";
import { Link } from "react-router-dom";
import Loading from "./Spinner/spinner";



const BackgroundImageWithTextCard = (props) => {
    const { data, isLoaded, error } = useApiRequest(`https://resania.com/${props.endpoint}`);
    return isLoaded ? (   
      <div className='container h-96'>
      <Loading/>
      </div>
      ) : data ? (
    <div>
      <div className="lg:grid lg:grid-cols-1 lg:gap-8 lg:items-center relative">
        <Carousel cols={3} rows={2} gap={10}>
          {data.slice(0, props.numberToShow).map((item) => (
            <Carousel.Item key={item.id}>
              <Link to={`/resania/${props.link}/${item.slug}`}>
              <article
                className="relative w-full h-60 bg-cover bg-center group rounded-lg overflow-hidden shadow-lg hover:shadow-2xl  transition duration-300 ease-in-out"
                style={{ backgroundImage: `url(${item.img_url})` }}
              >
                <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:opacity-75 transition duration-300 ease-in-out"></div>
                <div className="relative w-full h-full px-4 sm:px-6 lg:px-4 flex justify-center items-center">
                  <h3 className="text-center">
                    <a
                      className="text-center text-3xl font-extrabold tracking-tight sm:text-5xl lg:text-4xl text-white capitalize hover:text-gray-300"
                      href={`/resania/${props.link}/${item.slug}`}
                    >
                      <span className="absolute inset-0"></span>
                      {item.activity_name} {item.title}
                    </a>
                  </h3>
                </div>
              </article>
              </Link>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
    ) : error ? (
      <p>{error}</p> 
    ) : 'Ooops something when wrong , please refresh the page 1 ....Awkward'
};

export default BackgroundImageWithTextCard;
